<template>
  <div id="profile">
    <Hero
      v-bind:title="$t('views.profile.title')"
    />

    <div class="content-wrapper">
      <ProfileUpdateForm/>
    </div>

  </div>
</template>

<script>
import ProfileUpdateForm from '@/components/profile/ProfileUpdateForm.vue'
import Hero from '@/components/plans/Hero.vue'

export default {
  name: 'Profile',
  components: {
    Hero,
    ProfileUpdateForm
  },
  data () {
    let user = JSON.parse(localStorage.getItem('user'))
    return {
      user: user.userInfo,
    }
  }
}
</script>

<style lang="scss">
#profile {
  .hero {
    background-image: url('../assets/backgrounds/smoke-profile.png');
    background-size: contain;
    min-height: 180px;
  }
}
</style>
